import { useRouter } from 'next/router'
import React, { useContext, useEffect } from 'react'

import MainLoader from '@/components/Common/MainLoader'
import MyProfileContext from '@/components/Context/MyProfileContext'
import { dispatchRoleDashboard } from '@/lib/auth/withAuthent'
import { useEntity } from '@/lib/hook/useEntity'

const Index = () => {
  const { loadingProfile, dataMyProfile } = useContext(MyProfileContext)
  const router = useRouter()
  const entityCurrent = useEntity()

  useEffect(() => {
    !loadingProfile &&
      dispatchRoleDashboard({
        router,
        entityCurrent,
        dataMyProfile,
      })
  }, [loadingProfile, dataMyProfile])
  return (
    <>
      <MainLoader fullScreen />
    </>
  )
}

export default Index
